import { reactMount } from '@/lib/reactMount'
import { useRef } from 'react'
import { Button } from '@/components/Button'
import { Tag } from '@/components/Tag'

export const cardBlock = ({ dataset, umbraco }) => {
  const umbracoRef = useRef(umbraco || JSON.parse(dataset.umbraco))
  umbraco ||= umbracoRef.current
  const theme = umbraco.Theme || 'light'
  const backgroundColor = umbraco.BlockBackground ? `#${umbraco.BlockBackground}` : '#ffffff'

  const itemCount = umbraco.Blocks.length
  let itemCountClasses = ''

  if (itemCount === 4) itemCountClasses = 'w-full grid md:grid-cols-2 lg:grid-cols-4'
  if (itemCount === 3) itemCountClasses = 'w-full grid md:grid-cols-3'
  if (itemCount === 2) itemCountClasses = 'w-full grid md:grid-cols-2'

  return (
    <div data-theme={theme} className='_block-section _cardBlock-section relative isolate py-16 md:px-4 lg:px-10 xl:px-24' style={{ backgroundColor }}>
      <div className='text-center mx-auto max-w-7xl px-4 sm:px-6 lg:px-8'>
        {
          umbraco.Title &&
            <h2 className='text-3xl font-extrabold sm:text-5xl mb-4 tracking-tight text-[--theme-highlight]'>{umbraco.Title}</h2>
        }
        {
          umbraco.SubTitle &&
            <h3 className='text-2xl font-extrabold sm:text-3xl tracking-tight text-[--theme-text-alt-3]'>{umbraco.SubTitle}</h3>
        }
        <div
          className='max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-pretty text-base font-semibold mt-5 first:mt-0'
          dangerouslySetInnerHTML={{ __html: umbraco.Summary }}
        />
      </div>
      <div className={`mx-auto max-w-[1464px] px-4 xl:px-3 pt-12 isolate gap-4 ${itemCountClasses}`}>
        {umbraco.Blocks.map((block, index) => {
          const TagName = block.Button?.Url ? 'a' : 'div'
          const tagProps = block.Button?.Url
            ? { href: block.Button.Url, target: block.Button.Target || '_self' }
            : {}

          return (
            <TagName
              key={`card-block-${index}`}
              className='group relative text-[--theme-text]'
              {...tagProps}
            >
              <div className='h-[400px] relative rounded-[20px] overflow-hidden'>
                {
                  block.Media && block.Media.Image &&
                    <img className='absolute inset-0 object-cover w-full h-full' src={block.Media.Image.Url} alt={block.Media.Image.AltText} />
                }
                <div className='absolute inset-0 bg-black opacity-10' />
                {block.Label &&
                  <Tag className='absolute top-4 left-4 z-10'>{block.Label}</Tag>}
              </div>
              <div className='py-4 px-2 inset-0 flex flex-col'>
                <h3 id={`card-block-${index}`} className='text-xl text-primary-900 font-extrabold line-clamp-3'>
                  {block.Title}
                </h3>
                {
                  block.Button &&
                    <div data-theme='blue' className='grow flex items-end'>
                      <Button
                        noInteraction
                        variant='link'
                      >
                        {block.Button?.Name || 'Learn more'}
                      </Button>
                    </div>
                }
              </div>
            </TagName>
          )
        })}
      </div>
    </div>
  )
}

reactMount('cardBlock', cardBlock)
